import React from 'react';
import { Button } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from '../PaymentDetailsComponent.styles';
import useBapCtaClickGtm from '../../../core/gtm/hooks/useBapCtaClickGtm';
import usePaymentCalculatorModal from '../../PaymentCalculator/usePaymentCalculatorModal';
const EditLabelLink = themeStyles.apply(Button, 'EditLabelLink');
const PaymentCalculatorModalAnchor = ({ calculatorId, componentType, }) => {
    const { t } = useTranslation();
    const { openModal } = usePaymentCalculatorModal(calculatorId);
    const { fireGtmEvent } = useBapCtaClickGtm();
    const linkText = t('Pages.Bap.editButton');
    const handleOpenModal = () => {
        openModal();
        fireGtmEvent({
            ctaType: 'payment option',
            ctaPlacement: 'summary sticky',
            componentType,
            linkText,
        });
    };
    return (React.createElement(EditLabelLink, { styling: "tertiary", onClick: handleOpenModal, "data-testid": "cy-payment-frequency-edit-label", fontWeight: "bold" }, linkText));
};
export default PaymentCalculatorModalAnchor;
